export default __webpack_public_path__ + "static/media/brake-motors.6cf6f613.png";